import React, { useEffect, useRef } from 'react';
import parse from 'html-react-parser';
import sanitizeHTML from 'sanitize-html';
import { gtagEnvelope } from '~/common/util/gtagEnvelope';

export interface ConvertStringToReactProps {
  htmlString: string;
  errorCode?: string;
}

export const ConvertStringToReact = ({ htmlString, errorCode }: ConvertStringToReactProps) => {
  const containerRef = useRef<HTMLDivElement>(null);

  const sanitizeHtmlString = sanitizeHTML(htmlString, {
    allowedSchemes: ['http', 'https', 'mailto', 'tel'],
  });

  useEffect(() => {
    const container = containerRef.current;
    if (!container || !errorCode) return;

    const links = container.querySelectorAll('a');
    links.forEach((link) => {
      link.addEventListener('click', handleLinkClick);
    });

    return () => {
      links.forEach((link) => {
        link.removeEventListener('click', handleLinkClick);
      });
    };
  }, [sanitizeHtmlString]);

  const handleLinkClick = (event: MouseEvent) => {
    const target = event.target as HTMLAnchorElement;
    const href = target.href;
    gtagEnvelope('event', 'trial_page_error_link', {
      cta_url: href,
      error_number: errorCode,
    });
  };

  return <div ref={containerRef}>{parse(sanitizeHtmlString)}</div>;
};
